class SelectController {
	constructor($timeout, $document) {
		this.$timeout = $timeout;
		this.$document = $document[0];
	}

	$onInit() {
		this.dispalyField = this.dispalyField ? this.dispalyField : 'name';
		this.idField = this.idField ? this.idField : 'id';
		this.listValue = this.listValue ? this.listValue : [];
		this.selectedValue = this.selectedValue ? this.selectedValue : this.listValue.length ? this.listValue[0][this.idField] : undefined;
		this.showList = false; //Attribute to switch the lis visibility
		this.searchSelectedItem();
	}

	$onChanges(changes) {
		if(changes.listValue)
			this.searchSelectedItem();
	}

	/*
     * Callback called when change selection of the select component
     */
	changeCallback() {
		if (angular.isFunction(this.onChange))
			this.onChange({
				$event: {
					id: this.selectedValue
				}
			});
	}

	/*
    * Function called when input is clicked
    */
	inputClick() {
		this.setShowList(!this.showList);
	}

	/*
    * Function called when expand arrow is clicked
    */
	expandListClick() {
		this.setShowList(!this.showList);
		this.inputSetFocus();
	}

	/*
    * Function called when collapse arrow is clicked
    */
	collapseListClick() {
		this.inputSetFocus();
	}

	/*
    * Function called when input lost focus
    */
	inputBlur() {
		if (this.showList) {
			let _this = this;
			this.$timeout(function () {
				_this.setShowList(false);
			}, 200);
		}
		this.inputFocus = false;
	}

	/*
     * Function called to stablish focus of the input
     */
	inputSetFocus() {
		this.inputFocus = true;
	}

	/*
     * Change selected value of the select when an element is clicked
     */
	changeSelectedValue(item) {
		this.selectedValue = item[this.idField];
		this.searchSelectedItem();
		this.setShowList(false);
		this.inputSetFocus();
		this.changeCallback();
	}

	/*
     * Find the index and the text of the selected element.
     */
	searchSelectedItem() {
		let showSelectedItemText = this.showSelectedItemText;
		let index = null;
		this.listValue.map((item, i) => {
			if (item[this.idField] === this.selectedValue) {
				showSelectedItemText = item[this.dispalyField];
				index = i;
			}
		});
		this.selectedIndex = index;
		this.showSelectedItemText = showSelectedItemText;
	}

	/*
     * Change selected value of the select when up and down arrows are pressed
     */
	onKeyDown(event) {
		if (event.keyCode === 40 || event.keyCode === 38) {
			if (event.keyCode === 40 && this.selectedIndex < this.listValue.length - 1)
				this.selectedIndex++;
			else if (event.keyCode === 38 && this.selectedIndex > 0)
				this.selectedIndex--;
			this.selectedValue = this.listValue[this.selectedIndex][this.idField];
			this.showSelectedItemText = this.listValue[this.selectedIndex][this.dispalyField];
			this.changeCallback();
		} else if (event.keyCode === 13)
			this.setShowList(!this.showList);
	}

	/*
    *It defiine is the list of element is visible or not
    */
	setShowList(value) {
		this.showList = value;
	}
}

export default SelectController;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/select/select.controller.js